import * as React from 'react';
/**
 * Component intended for use as a child of the `<Experiment>` component to conditionally
 * render the control content of an experiment based on experiment bucket.
 *
 * Unlike `<ExperimentVariant>` this component has no `bucket` prop as we have chosen bucket
 * value 0 to indicate control.
 */
export var ExperimentControl = function (props) { return (React.createElement(React.Fragment, null, props.children || null)); };
//# sourceMappingURL=experiment-control.js.map